import { instance } from '@/libs/api/instance.js'

/**
 * Create a pair of tokens
 *
 * @param {Object} data - An object containing the data fields to generate a pair of JWT
 *  @property {string} [id] - unique ID
 *  @property {Array} [allowIps] - list of IP adresses
 *  @property {boolean} [withMfa] - should use sign methods
 *  @property {string} [fingerprint] - unique ID of device
 *  @property {number} [expiredAt] - date of tokens expiry
 *  @property {string} [app] - custom name
 *
 *  @param {number|boolean} [validdate=0] - An optional parameter that indicates whether the server should validate the request data
 *  @return {Promise<AxiosResponse<any>>}
 */

export const createJWTokens = (data, { validate, signToken }) => {
  return instance.post('/v2/auth', data, {
    params: { validate: Number(validate), signToken },
  })
}
